// eslint-disable-next-line import/prefer-default-export
export const fieldOrganization = [
  {
    key: 'no',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      maxWidth: '80px',
    },
    tdClass: 'text-black w-[40px]',
    class: '',
  },
  {
    key: 'name',
    label: 'Nama',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
    tdStyle: {
      maxWidth: '250px',
    },
  },
  {
    key: 'level',
    label: 'Level User',
    thClass: 'font-bold capitalize text-black',
    tdClass: 'px-2',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '150px',
    },
  },
  {
    key: 'product',
    label: 'Produk',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'total_accounts',
    label: 'Jumlah Akun',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '150px',
    },
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: 'font-bold text-black text-center',
    tdClass: 'text-center',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '100px',
      minWidth: '100px',
    },
  },
]

export const fieldDetailOrganization = [
  {
    key: 'no',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      maxWidth: '80px',
    },
    tdClass: 'text-black w-[40px]',
    class: '',
  },
  {
    key: 'email',
    label: 'Email Partner',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
    tdStyle: {
      maxWidth: '250px',
    },
  },
  {
    key: 'level',
    label: 'Level User',
    thClass: 'font-bold capitalize text-black',
    tdClass: 'px-2',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '150px',
    },
  },
  {
    key: 'product',
    label: 'Produk',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'komcards_score',
    label: 'Komcards Score',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '150px',
    },
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: 'font-bold text-black text-center',
    tdClass: 'text-center',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '120px',
      minWidth: '120px',
    },
  },
]

export const ignoredKeys = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
  'Tab',
  'Escape',
  'Enter',
  'Control',
  'Alt',
  'Shift',
  'Meta',
  'CapsLock',
]
